module.exports = __webpack_public_path__ + "static/trioimg3-6a9ab0b7c491f35adb053d218786e414.png";